import { MenuNavItem } from '../../Navigation/elements/MenuActions'
import { TransformItemsStructure } from '../../Navigation/elements/NavigationMenu/utils/transformItemsStructure'

export const getIconName = (navItem?: TransformItemsStructure | MenuNavItem) => {
  const { iconLeft } = navItem || {}
  return iconLeft && typeof iconLeft === 'string' ? iconLeft : undefined
}
